import React from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { EXTENSION, TITLE_EN, TITLE_RU } from "../constants";

const EpisodeFile = (
    {
        file,
        onDelete,
        onUpdate,
    }
) => {
    const fileExtension = file[EXTENSION].toUpperCase();

    return (
        <div className="episode-file">
            <span>{fileExtension}</span>
            <span>
                <b>{file[TITLE_RU] || file[TITLE_EN]}</b>
            </span>
            <div className="episode-file__buttons">
                {!file.link && (
                    <Button href={file.url} target="_blank"><Glyphicon glyph="download" /></Button>
                )}
                <Button onClick={() => onUpdate(file)}><Glyphicon glyph="edit" /></Button>
                <Button onClick={() => onDelete(file.id)} bsStyle="danger"><Glyphicon glyph="trash" /></Button>
            </div>
        </div>
    );
};

export default EpisodeFile;
